import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_URL + "api/recommendations";

// Create axios instance with auth
const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const useRecommendations = () => {
  const getAllRecommendations = async () => {
    try {
      const response = await api.get("/");
      return response.data;
    } catch (error) {
      console.error("Error fetching recommendations:", error);
      throw error;
    }
  };

  const getRecommendationById = async (id) => {
    try {
      const response = await api.get(`/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching recommendation:", error);
      throw error;
    }
  };

  const createRecommendation = async (recommendationData) => {
    try {
      const response = await api.post("/", recommendationData);
      return response.data;
    } catch (error) {
      console.error("Error creating recommendation:", error);
      throw error;
    }
  };

  const toggleLike = async (recommendationId, userId) => {
    try {
      const response = await api.post(`/${recommendationId}/like`, { userId });
      return response.data;
    } catch (error) {
      console.error("Error toggling like:", error);
      throw error;
    }
  };

  const getUserRecommendations = async (userId) => {
    try {
      const response = await api.get(`/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching user recommendations:", error);
      throw error;
    }
  };

  const getRatingAndLikes = async (id) => {
    try {
      const response = await api.get(`/${id}/rating`);
      return {
        rating: response.data.rating,
        likesCount: response.data.likesCount,
        isLiked: response.data.isLiked,
      };
    } catch (error) {
      console.error("Error fetching rating and likes:", error);
      throw error;
    }
  };

  const filterRecommendations = async (type) => {
    try {
      const response = await api.get("/filter", {
        params: { type },
      });
      return response.data;
    } catch (error) {
      console.error("Error filtering recommendations:", error);
      throw error;
    }
  };

  const deleteRecommendation = async (id, userId) => {
    try {
      console.log("API deleteRecommendation called with:", { id, userId });
      const response = await api.delete(`/${id}?userId=${userId}`);
      console.log("Delete response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error deleting recommendation:", error);
      throw error;
    }
  };

  return {
    getAllRecommendations,
    getRatingAndLikes,
    getRecommendationById,
    createRecommendation,
    toggleLike,
    getUserRecommendations,
    filterRecommendations,
    deleteRecommendation,
  };
};

export default useRecommendations;
